import axios from "@/api/axiosInstance";
import { FetchTransactionHistoryReportParams } from "./types";

export const fetchTransactionHistoryReportCsv = async (
  params: Omit<FetchTransactionHistoryReportParams, "page" | "pageSize"> = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/reports/transaction-history/export",
    { responseType: "blob", params },
  );
  return response.data;
};
